import { z } from 'zod';

const EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

/**
 * Where the quote goes and the personal line on top. `to` is required only when the draft has
 * no email of its own (the backend's missing_email); otherwise blank means the draft's email.
 * The message limit is the backend's 2000.
 */
export function invoiceSchema(needsRecipient: boolean) {
  return z.object({
    to: z
      .string()
      .trim()
      .refine((v) => !needsRecipient || v !== '', { error: 'draftOrders:invoice.validation.to' })
      .refine((v) => v === '' || EMAIL.test(v), { error: 'draftOrders:invoice.validation.email' }),
    message: z.string().trim().max(2000, { error: 'draftOrders:invoice.validation.message' }),
  });
}

export type InvoiceFormInput = z.input<ReturnType<typeof invoiceSchema>>;
export type InvoiceFormOutput = z.output<ReturnType<typeof invoiceSchema>>;
